import React, { useEffect, useState, useContext } from "react";
import { useParams } from "react-router-dom";
import URLstateContext from "../../../provider/CommonContext";
import './NewsEquity.css';
import { useLocalStorage } from "../../utils/useLocalStorage";
import Accordion from "react-bootstrap/Accordion";
import { useNavigate } from 'react-router-dom';
import renderHTML from 'react-render-html';
import { Modal } from "react-bootstrap";

function NewsEquity(props) {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [modalIsOpen, setIsOpen] = React.useState(false);
  let getData;
  const { BaseURL } = useContext(URLstateContext);
  const [data, setData] = useState([]);
  const [filteredNewsData, setFilteredNewsData] = useState([]);
  const [cocode, setcocode] = useLocalStorage("cocode", "");
  let getCoCode = props.coCode;
  let getCompName = props.requestcompname;
  const navigate = useNavigate();                     
  const [companyInfo, setCompanyInfo] = useState([]);                     

  let companyInformation;
  useEffect(() => {
    const newsUrl = BaseURL + "NewsEquity";
    if (props.coCode != "") {
      fetch(`${newsUrl}/${getCoCode}/5`)
        .then((response) => response.json())
        .then((data) => {
          getData = data.data;
          setData(getData);
          companyInformation = data.data;
          //console.log(data.data)
          setCompanyInfo(companyInformation);
          // console.log("data", companyInformation);
         // console.log("data", companyInformation);
          // console.log(getData[0].ArtText)
        })
        .catch((error) => {
          // console.log("not found the api 1233333");
        });
    }
  }, [props.coCode]);
  // const routeChange = (event) => {
  //   const compcocode = event.currentTarget.dataset.id;
  //   alert("compcode:" + compcocode);


  //   //  window.open( "/DetailsNews/" , "_blank");
  //   // navigate("/DetailsNews/" + compcocode, {
  //   // state: { coCode: `${compcocode}` },
  //   // });
  // };
  const [isActive, setActive] = useState("false");
  const [text, setText] = useState("More");
  // const knowMoreBtn = () => {
  //   // const fetchId = e.currentTarget.getAttribute('data-id');
  //   //  setActive(!isActive);
  //   // setText("Less");

  //   handleShow();
  // };
  // const handleClosePopup = () => {
  //  setShow(false);
  // }
  // const newsModal =(e) =>{
  //   const fetchId = e.currentTarget.getAttribute('data-id');
  //   let filteredCompanyInformation = companyInfo.filter(oneData => { return parseInt(oneData['SNo']) === parseInt(fetchId)})
  //   //console.log(filteredCompanyInformation)
    
  //    setFilteredNewsData(filteredCompanyInformation)
  //   handleShow();
  // }

  const routeChange = (event) => {
    const fetchId = event.currentTarget.getAttribute('data-id');
    const fetchHead = event.currentTarget.getAttribute('data-head');
    window.open("/Detail-News/" + fetchId + "/" + fetchHead.replace(/ /g, '-').replace('&', 'and').replace('/', 'slash').replace('?', 'questionMark').replace('=', 'isEqualsTo').replace(/\./g,'').replace(':', 'colon').replace('%', 'Percent'), '_blank');
};

const clickMoreNews = () => {
  window.open("/CompanyProfile/Company-News/" + getCompName, '_blank');
}

  return (
    <>
      <section className="peer-sc">
        <div className='container table-boxNews'>
          <div className='row'>
            <div className='col-md-12'>
              <div className="MoreNewsDiv">
              <h3 className="mainHeadingNews">Company News</h3>
              {(data != null)?<span className="moreContentSnap" onClick={clickMoreNews} >See More</span>:''}
              </div>
              {(data === null) ? <h5 className="errormsgComNew">No Data Available !!!</h5> : ''}
              {data && data.map(
                ({ co_code, SNo, Heading, Date, Time, ArtText, memo }) => (

                  <div className="newsDiv">
                     {/* <td><h6 data-id={SNo}>{Heading} </h6></td> */}
                    {/* <a data-id={SNo} onClick={newsModal}>
                 
                      <a onClick={knowMoreBtn} > */}
                        {/* <span>Read {text}</span> */}
                        <h6 className="newhead" onClick={routeChange} data-head={Heading} data-id={SNo}>{Heading} </h6>
                        <p> {(Date.split('T')[0])}  ({Time})</p><hr></hr>
                      {/* </a>
                    </a> */}

                  </div>
                ))}

              {/* {filteredNewsData &&
                filteredNewsData.map(({ co_code, SNo, Heading, Date, Time, ArtText, memo }) => (
                  <Modal show={show} className="modal company-snap-modal">

                    <Modal.Body id="modal_info">
                      <div className="titleCompany">{Heading}</div>
                      <div className="btnDiv">
                        <div className="btncl" onClick={handleClosePopup} > X </div>
                      </div>
                      <div className="infoCompany">{renderHTML(ArtText)}</div>
                    </Modal.Body>

                  </Modal>
                ))} */}
            </div>

          </div>
        </div>
      </section>

    </>
  )
}

export default NewsEquity